<template>
    <v-layout wrap fill-height>
        <v-flex xs12 >
            <v-layout justify-center align-center>
                <v-flex sm12 md11 xl10>
                    <v-form
                            v-model="valid"
                            class="login-form"
                            row
                            justify-center>

                        <v-card elevation="10"  class="form-wrapper pa-6 ">

                          <v-text-field
                                @keyup.enter="login"
                                ref="emailInput"
                                autofocus
                                v-model="email"
                                :rules="emailRules"
                                label="E-mail"
                                required
                            ></v-text-field>

                            <v-text-field
                                @keyup.enter="login"
                                ref="passwordInput"
                                v-model="password"
                                :rules="passwordRules"
                                label="Contraseña"
                                type="password"
                                class="my-1"
                                required
                            ></v-text-field>

                            <v-btn
                                    rounded
                                    class="mx-0 my-1 mt-4"
                                    :loading="loadingLogin || firstLoadingLogin"
                                    color="primary"
                                    @click="login"
                                    style="width: 100%"
                            >Ingresar</v-btn>

                        </v-card>

                        <v-sheet height="20" color="transparent"></v-sheet>

                        <!--<kimsa-facebook-button
                                retrieve-user-only
                                :disabled="disabled"
                                v-on:success="facebookSuccess"
                                v-on:error="facebookError"
                        ></kimsa-facebook-button>-->

                        <v-flex sm12 class="text-center ">
                            <div class="mt-2">
                                 <a  @click="showReset">Recuperar contraseña</a>
                            </div>
                        </v-flex>

                    </v-form>



                </v-flex>
            </v-layout>
        </v-flex>
        <kimsa-password-reset ref="resetDialog"/>
        <service-provider-sign-up
                :model="showSpecialistSignUp"
                v-on:change="onChange"
        ></service-provider-sign-up>
    </v-layout>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'
    import ServiceProviderSignUp from '@/components/common/signup/ServiceProviderSignUp.vue'
    import KimsaFacebookButton from '@/components/common/KimsaFacebookButton'
    import KimsaPasswordReset from '@/components/common/KimsaPasswordReset'
    import DevByKimsa from "@/components/common/DevByKimsa";

    export default{
        name: 'LoginDialog',
        components: {
          DevByKimsa,
            KimsaFacebookButton,
            KimsaPasswordReset,
            ServiceProviderSignUp
        },
        data(){
            return {
                showSpecialistSignUp: false,
                valid: false,
                disabled: false,
                email: '',
                password: '',
                emailRules: [
                    v => !!v || 'E-mail es obligatorio',
                    v => /.+@.+/.test(v) || 'E-mail inválido'
                ],
                passwordRules: [
                    v => !!v || 'Contraseña es obligatoria',
                    v => v.length >= 6 || 'Debe tener al menos 6 caracteres'
                ],
            }
        },
        computed: {
            ...mapState(['currentUser', 'loginMessage', 'loadingLogin', 'firstLoadingLogin'])
        },
        mounted(){
          const vm = this

          setTimeout(function(){
            vm.$refs.passwordInput.focus()
          }, 300)

          setTimeout(function(){
            vm.$refs.emailInput.focus()
          }, 500)
        },
        methods: {
            ...mapMutations(['showSnackBar', 'setLoginLoading']),
            onChange(show){
                this.showSpecialistSignUp = show
            },
            showReset(){
                this.$refs.resetDialog.show()
            },
            async facebookSuccess(authResponse){
                var vm = this
                vm.disabled = true

                const loginResponse = await ApiUtils.loginWithSocial(authResponse.accessToken)
                if (loginResponse.code != 200) {
                    const json = await loginResponse.json()
                    vm.$emit('error', json)
                    vm.disabled = false
                    return
                }

                vm.disabled = false
                vm.$emit('success', authResponse)

            },
            async facebookError(){
                var vm = this
                vm.showSnackBar('Ocurrio un error intentando ingresar', 'secondary')
            },
            async login(){

                var vm = this
                if(!vm.valid)   {
                    vm.showSnackBar('Datos incorrectos', 'secondary')
                    return
                }

                vm.disabled = true
                vm.$store.commit('setLoginLoading', true)
                const response = await ApiUtils.login(vm.email, vm.password, true)
                vm.$store.commit('setLoginLoading', false)
                vm.disabled = false

                if (response.code == 401) {
                    vm.showSnackBar('Usuario y/o password incorrecto(s)', 'secondary')
                    return
                }

                vm.$emit('success', response)

            }
        },
        watch:{
            firstLoadingLogin(val){
                var vm = this
                if(!val && !!vm.currentUser){
                    vm.$emit('success')
                }
            }
        }
    }

</script>

<style >

    .form-wrapper{
        border-radius: 10px;
    }

   /* .login-form input:-webkit-autofill,
    .login-form input:-webkit-autofill:hover,
    .login-form input:-webkit-autofill:focus,
    .login-form input:-webkit-autofill:active  {
        -webkit-box-shadow: 0 0 0 30px #11111f inset !important;
    }

    .login-form input:-webkit-autofill {
        -webkit-text-fill-color: #fff !important;
    }

    @-webkit-keyframes autofill {
        to {
            color: #000000;
            background: transparent;
        }
    }

    .login-form input:-webkit-autofill {
        -webkit-animation-name: autofill;
        -webkit-animation-fill-mode: both;
    }*/
</style>
